import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UIState {
  posExpanded: boolean;
  setPosExpanded: (expanded: boolean) => void;
  togglePosExpanded: () => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      posExpanded: false,
      setPosExpanded: (expanded) => set({ posExpanded: expanded }),
      togglePosExpanded: () =>
        set((state) => ({ posExpanded: !state.posExpanded })),
    }),
    { name: "coffee-pos-ui" },
  ),
);
